import { create, test, enforce, each } from 'vest';

export const facebookPostValidation = create((data) => {
    test('message', 'Message can not be blank.', () => {
        enforce(data.message)
            .isNotEmpty();
    });
});

export const tweetValidation = create((data) => {
    if (data.media && data.media.length < 1) {
        test('tweet', 'Tweet can not be empty.', () => {
            enforce(data.message)
                .isNotEmpty();
        });
    }

    test('tweet', 'Tweet can not exceed 280 characters.', () => {
        enforce(String(data.message).length)
            .lessThan(280)
    });
});

export const scheduleValidation = create((data) => {
    test('date', 'Valid date is required.', () => {
        enforce(data.date)
            .isNotEmpty();
    });

    // The <Time /> component does a good job...
    // test('time', 'Time is required.', () => {
    //     enforce(data.message)
    //         .isNotEmpty();
    // });
});

export default {
    post: tweetValidation,
    schedule: scheduleValidation
};
